import type { Api } from "../../../data/api";
import type { OutboxRow, OutboxSummary } from "./model";

/** Lader und Aktionen des Postausgangs (0041, 0056). Die Datenbank prüft, dass nur Admins lesen und handeln. */

export async function ladePostausgang(api: Api, orgId: string): Promise<{ rows: OutboxRow[]; summary: OutboxSummary }> {
  const [rows, summary] = await Promise.all([
    api.read<OutboxRow[] | null>("outbox_list", { p_org: orgId, p_limit: 500 }),
    api.read<OutboxSummary | null>("outbox_summary", { p_org: orgId }),
  ]);
  return { rows: rows ?? [], summary: summary ?? { pending: 0, sent: 0, failed: 0, skipped: 0, dry_run: 0 } };
}

/**
 * Erneut senden: der Auftrag wird wieder offen; fehlt weiter ein Wert, meldet die Datenbank ihn gleich wieder.
 * Mit neuer Adresse (Tippfehler, Buchhaltung gewechselt) und auf Wunsch auch im Profil des Creators bzw. der Marke (0056).
 * Bewusst übersprungene Mails (storniert, abgesagt, erledigt) lehnt die Datenbank ab.
 */
export async function erneutSenden(api: Api, id: string, neu?: { recipient?: string | null; updateMaster?: boolean }): Promise<{
  status: string; error: string | null; recipient?: string; master?: string | null;
}> {
  const recipient = neu?.recipient?.trim() || null;
  return api.rpc("outbox_retry", { p_id: id, ...(recipient ? { p_recipient: recipient } : {}), ...(recipient && neu?.updateMaster ? { p_update_master: true } : {}) });
}

export async function verwerfen(api: Api, id: string): Promise<void> {
  await api.rpc("outbox_cancel", { p_id: id });
}

/** 0253 (K-201): nach der Bestätigung alle zurückgehaltenen Mails der letzten 30 Tage erneut einreihen; Erledigtes bleibt liegen. */
export async function zurueckgehalteneSenden(api: Api, orgId: string): Promise<{ erneut: number; liegen: number }> {
  return api.rpc("outbox_resend_unverified", { p_org: orgId });
}
